import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { forkJoin, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CommissionMotive } from 'src/oldApp/model/commission-motive';
import { CommissionSimulator } from 'src/oldApp/model/commission-simulator';
import { CommissionSimulatorService } from 'src/oldApp/services/commission-simulator.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { CatalogModel, CommissionProductEmployeeJobWResult } from 'src/app/model/other-catalogs-models';
import { CatEmployeeJobService } from 'src/app/services/cat-employee-job.service';
import { ModalConfirmComponent } from 'src/oldApp/shared/modal-confirm/modal-confirm.component';
import { ModalDateSelectionComponent } from 'src/oldApp/shared/modal-date-selection/modal-date-selection.component';
import { ToastrService } from 'ngx-toastr';
import { CommissionFisofoService } from 'src/oldApp/services/commission-fisofo.service';
import { ModalAdjustCommissionComponent } from 'src/app/shared/modal-commission-adjust/modal-commission-adjust.component';
import { CommissionAdjustment } from 'src/app/model/commission-adjustment.model';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { ModalAdditionalCommissionPromotorComponent } from 'src/oldApp/shared/modal-commission-additional-promotor/modal-commission-additional-promotor.component';
import { ModalAdditionalCommissionCreditComponent } from 'src/oldApp/shared/modal-commission-additional-credit/modal-commission-additional-credit.component';
import { TargetPromotor } from 'src/oldApp/model/target-promotor.model';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-commission-simulator',
  templateUrl: './commission-simulator.component.html',
  styleUrls: ['./commission-simulator.component.css'],
})
export class CommissionSimulatorComponent implements OnInit {
  @Input() isChild:string="n";
  @Input() headerText:string="Simulador"
  @Input() btnGenText:string="Generar"
  @Input() btnGenText2:string="Simular"

  // estado pagina
  public page='ComissionSimulator';
  public labelFechaIni:string="Fecha";

  public viewStatus:number=0;
  public viewMonthDD:number=0;
  public viewDateIni:number=0;
  public viewDateFin:number=0;
  public viewCoordExt:number=0;
  public viewCheckSimulate:number=1;
  public viewCheckComplements:number=0;
  public viewCommissionsBtn:number=0;
  public viewComplementsBtn:number=0;
  public loading:number=0;
  public loading2:number=0;
  public tabs:any[]=[];
  public active: any;
  public isfirst:boolean=false;
  public isSimulated:boolean=false;
  public isGroup:boolean=false;

  public listMonths:CatalogModel[]=[];
  public listMonthsFiltered:CatalogModel[]=[];
  public listCommissionMotives:CommissionMotive[]=[];
  public listCommissionMotivesFiltered:CommissionMotive[]=[];
  public tableItems:CommissionSimulator[]=[];
  public tableItemsFiltered:CommissionSimulator[]=[];

  public createdDateIni:string=null;
  public createdDateFin:string=null;
  public selectedDateIni:string=null;
  public selectedDateFin:string=null;
  public selectedMotive:any[]=[];
  public listCommissionProductEmployee: CommissionProductEmployeeJobWResult [] = [];
  public saveListCommissionProductEmployee: CommissionProductEmployeeJobWResult [] = []; 

  public simulate:boolean=true;
  public complements:boolean=false;
  public initYear:number=null;
  public initMonth:number=null;
  public motiveCatalog:CatalogModel[]=[];
  public commissionGroupCatalog:CatalogModel[]=[];

  public selectedMonths:any[]=[];
  public selectedCommissionGroup:any[]=[];
  public selectedCommissionGroupInit:any[]=[];

  public totalCommissionMotive0:number=0;
  public totalCommissionMotive1:number=0;
  public totalCommissionMotive2:number=0;
  public totalCommissionMotive3:number=0;
  public totalCommissionMotive4:number=0;
  public totalCommissionMotive5:number=0;
  public totalCommissionMotive6:number=0;
  public totalCommissionMotive7:number=0;
  public totalCommissionMotive8:number=0;
  public selectedCommission:any=null;
  public comisionOriginalFinal:number=0;
  public comisionOriginalFinalByAsesor:number=0;
  public creditoMotivo:number=0;
  public dataPromotors:any[]=[];
  public dataGroups:any[]=[];


  // regionChartOptions: ChartOptions = {
  //   responsive: true
  // };
  // regionChartLabels: Label[] = ["Pending", "InProgress", "OnHold", "Complete", "Cancelled"];
  // regionChartType: ChartType = 'bar';
  // regionChartLegend = true;
  // regionChartPlugins:any = {'backgroundColor': [
  //   "#FF6384",
  //   "#4BC0C0",
  //   "#FFCE56",
  //   "#E7E9ED",
  //   "#36A2EB"
  // ]}
  // public regionChartColors: Color[] = [
  //   { backgroundColor: 'gray' },
  // ]
  // regionChartData: ChartDataSets[] = [
  //   { data: [45, 37, 60, 70, 46], label: 'Task Status' }
  // ];

  @ViewChild(DataTableDirective, {static: false})
  private datatableElement: DataTableDirective;

  @ViewChild("nav", {static: false}) // Get a reference to the ngbNav
  nav: any;

  dtOptions: any = {};

  constructor(
    private commissionSimulatorService:CommissionSimulatorService,
    private commissionFisofoService:CommissionFisofoService,
    private catEmployeeJobService:CatEmployeeJobService,
    private utils:UtilitiesService,
    private modalService:NgbModal,
    private toastr:ToastrService
    //private modalCommissionCredit: ModalAdditionalCommissionCreditComponent
  ) { }

  ngOnInit() {
    let me = this;
    // opciones datatables
  this.dtOptions={
    order:[],
    responsive: true,
    columnDefs: [
       { responsivePriority: 1, width:100, targets: -1 },
    //   { responsivePriority: 2, width:100, targets: -2 },
    //   { responsivePriority: 3, width:100, targets: -3 },
    //   { responsivePriority: 4, width:100, targets: -4 },
    //   { responsivePriority: 5, width:100, targets: -5 },
    //   { responsivePriority: 6, width:100, targets: -6 },
    //   { responsivePriority: 7, width:100, targets: -7 },
    //   { responsivePriority: 8, width:100, targets: -8 },
    //   { responsivePriority: 9, width:100, targets: -9 },
    //   { responsivePriority: 10, width:100, targets: -10 },
    //   { responsivePriority: 11, width:100, targets: -11 }
    ],
    select: 'single',
    bLengthChange: true,
    searching :true,
    dom:'<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: [
      {
        text: 'Excel',
        action: () => {
          this.exportToExcel();
        }
      }/*,
      {
        text: 'Agregar',
        action: function () {
          if(me.isGroup){
            let modalGroup = me.modalService.open(ModalAdditionalCommissionPromotorComponent, {centered:true, size:'sm', backdrop:'static'});
          } else{
            let modal = me.modalService.open(ModalAdditionalCommissionCreditComponent, {centered:true, size:'lg', backdrop:'static'})
            modal.componentInstance.simulateDate=me.selectedDateIni;
            modal.result.then(
              data=> console.log(">> DATA: "+data),
              reason=> {
                console.log(">> JSON CREDITO: "+ JSON.stringify(reason));
                if(reason.toString() != "failure"){
                  let targetCredit = new TargetCredit();
                  targetCredit.iCreditId = reason.idCredito;
                  targetCredit.businessLineDescr = 'DOMICILIACION';
                  targetCredit.ownerTypeDescr = 'SHF';
                  targetCredit.productDescr = reason.producto;
                  targetCredit.afiliateDescr = reason.colectivo;
                  targetCredit.paymentDescr = reason.plazo;
                  targetCredit.financingId = reason.tipoPromocion;
                  targetCredit.employeeJobDescr = 'ASESOR INTERNO';
                  targetCredit.employeeId = reason.idPromotor;
                  targetCredit.employeeName = reason.nombrePromotor;
                  targetCredit.schemaDescr = 'COMISIÓN POR CLASIFICACIÓN DE PRODUCTO	';
                  targetCredit.collectDate = reason.fechaCobrado;
                  targetCredit.collectCapitalAmount = 0;
                  targetCredit.capitalAmount = reason.capital;
                  targetCredit.openingAmount = 0;
                  targetCredit.insuranceAmount = 0;
                  targetCredit.motiveDescr = 'OK';
                  targetCredit.collectCapitalAmountLastMonth = 0;
                  targetCredit.categoryDescr = 'CLASICO';
                  targetCredit.commission = reason.porcentajeComision;
                  targetCredit.commissionAmount = reason.montoComision;
                  targetCredit.salePromotionDescr = '';
                  targetCredit.salePromotionCommission = 0;
                  targetCredit.salePromotionCommissionAmount = 0;
                  targetCredit.commissionAdjustmentAmount = 0;
                  targetCredit.commissionAmountFinal = reason.montoComision;
                  targetCredit.executionDate = reason.fechaCobrado;
                  console.log(">> TARGET ADICIONAL: "+ JSON.stringify(targetCredit));
                  me.dataPromotors.push(targetCredit);
                  
                  // me.datatableElement.dtInstance.then((dtInstance: DataTables.Api)=> {
                  //   //me.tableItemsFiltered=me.dataPromotors;
                  //   dtInstance.clear();
                  //   dtInstance.rows.add(me.dataPromotors).draw(false);
                  // });
                }
              }
            );;
          }
        } 
      }*/
    ],
    // dom: 'Bfrtip',
    autoWidth:false,
    pagingType: 'full_numbers',
    paging:true,
    pageLength: 10,
    language: {
      processing: 'Procesando...',
      search: 'Buscar:',
      lengthMenu: 'Mostrar _MENU_ elementos',
      info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
      infoEmpty: 'Mostrando ningún elemento.',
      infoFiltered: '(filtrado _MAX_ elementos total)',
      infoPostFix: '',
      loadingRecords: 'Cargando registros...',
      zeroRecords: 'No se encontraron registros',
      emptyTable: 'No hay datos disponibles en la tabla',
      paginate: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Siguiente',
        last: 'Último'
      },
      aria: {
        sortAscending: ': Activar para ordenar la tabla en orden ascendente',
        sortDescending: ': Activar para ordenar la tabla en orden descendente'
      }
    }
  };

    console.log(">> isChild= ", this.isChild);
    this.viewStatus = 1;

    var currentTime = new Date()
    var currentMonth = currentTime.getMonth() + 1
    var currentYear = currentTime.getFullYear();
    var currentDay = currentTime.getDate();

    if(currentMonth === 1){ //Enero
      this.initMonth = 11;
      this.initYear = currentYear - 1;
    }
    if(currentMonth === 2){ //Febrero
      this.initMonth = 12;
      this.initYear = currentYear - 1;
    }
    if(currentMonth >= 3){
      this.initMonth = currentMonth - 2;
      this.initYear = currentYear;
    }

    let startDate = this.initYear + "-" + (this.initMonth<10 ? "0"+this.initMonth : this.initMonth) + "-01";
    let endDate =  currentYear + "-" + (currentMonth<10 ? "0"+currentMonth : currentMonth) + "-01";

    this.generateMonthsRange(startDate, endDate);
    //this.dtOptions.rowCallback=this.getRowCallback;
    this.getCatalogs();

    if(this.isChild === "y") {
      this.viewMonthDD = 0;
      this.viewCheckSimulate = 0;

      this.getCommissionSimulatorResults("0000", 1, 1, 4); //TERCIA
      this.selectedCommissionGroupInit.push(1);

      //let option1 = this.commissionGroupCatalog.filter(t=> t.id==1 );
      let option1 = new CatalogModel();
          option1.id = 1;
          option1.description = "TERCIA (REGIONAL/CALL CENTER)";

      this.selectedCommissionGroup.push(option1);

    }
  }

  ngAfterViewInit(): void {
    this.isfirst = true;
  }

  // HELPERS
  toggleSimulate=()=> {
    this.simulate=!this.simulate 
  console.log(this.simulate)
  } 
  toggleComplements=()=> {
    this.complements=!this.complements;
    this.createdDateIni = null;
    this.createdDateFin = null;
    if(this.complements) {
      this.viewMonthDD = 0;
      this.viewDateIni = 0;
      this.viewDateFin = 0;
    }else{
      this.viewMonthDD = 0;
      this.viewDateIni = 1;
      this.viewDateFin = 0;
    }
  };
  createdDateIniError=()=> this.createdDateIni!=="" && !this.createdDateIni;
  createdDateFinError=()=> this.createdDateFin!=="" && !this.createdDateFin;
  generateMonthsRange(startDate: string, endDate: string) {
    var start      = startDate.split('-');
    var end        = endDate.split('-');
    var startYear  = parseInt(start[0]);
    var endYear    = parseInt(end[0]);

    for(var i = startYear; i <= endYear; i++) {
      var endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
      var startMon = i === startYear ? parseInt(start[1])-1 : 0;
      for(var j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j+1) {
        var month = j+1;
        var displayMonth = month < 10 ? '0'+month : month;
        switch (month) {
          case 1:
            displayMonth="ENERO";
            break;
          case 2:
            displayMonth="FEBRERO";
            break;
          case 3:
            displayMonth="MARZO";
            break;
          case 4:
            displayMonth="ABRIL";
            break;
          case 5:
            displayMonth="MAYO";
            break;
          case 6:
            displayMonth="JUNIO";
            break;
          case 7:
            displayMonth="JULIO";
            break;
          case 8:
            displayMonth="AGOSTO";
            break;
          case 9:
            displayMonth="SEPTIEMBRE";
            break;
          case 10:
            displayMonth="OCTUBRE";
            break;
          case 11:
            displayMonth="NOVIEMBRE";
            break;
          case 12:
            displayMonth="DICIEMBRE";
            break;
          default:
              console.log("No such day exists!");
              break;
        }
        let option1 = new CatalogModel();
            option1.id = month;
            option1.description = displayMonth + " " + i;

        this.listMonthsFiltered.push(option1);
      }
    }
    //console.log(">> this.listMonthsFiltered= ", this.listMonthsFiltered);
  }
  getDisplayMonth=(startDate: string)=>{
    let splitDate = startDate.split("-");
    let month = splitDate[1];
    let displayMonth = "";
    switch (month) {
      case "01":
        displayMonth="ENERO";
        break;
      case "02":
        displayMonth="FEBRERO";
        break;
      case "03":
        displayMonth="MARZO";
        break;
      case "04":
        displayMonth="ABRIL";
        break;
      case "05":
        displayMonth="MAYO";
        break;
      case "06":
        displayMonth="JUNIO";
        break;
      case "07":
        displayMonth="JULIO";
        break;
      case "08":
        displayMonth="AGOSTO";
        break;
      case "09":
        displayMonth="SEPTIEMBRE";
        break;
      case "10":
        displayMonth="OCTUBRE";
        break;
      case "11":
        displayMonth="NOVIEMBRE";
        break;
      case "12":
        displayMonth="DICIEMBRE";
        break;
      default:
        console.log("No such day exists!");
        break;
    }
    return displayMonth + ' ' + splitDate[0];
  };

  // EVENTS
  onCloseTab(event: MouseEvent, toRemove: number) {
    this.tabs = this.tabs.filter(tab => tab.id !== toRemove);
    this.nav.select(1);
    event.preventDefault();
    event.stopImmediatePropagation();
  }
  onSelectDateIni(evt:any){
    let d = new Date(evt.year,evt.month-1,evt.day);
    let month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    this.selectedDateIni = [year, month, day].join('-');
     console.log(">> this.selectedDateIni= " + this.selectedDateIni);
  }
  onSelectDateFin(evt: any){
    let d = new Date(evt.year,evt.month-1,evt.day);
    let month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    this.selectedDateFin = [year, month, day].join('-');
    //console.log(">> selectedDateFin= " + this.selectedDateFin);
  }
  onMonthChange=(e: any[])=>{
    this.selectedMonths = e;
    if(this.selectedMonths.length > 0){
      let month = this.selectedMonths[0].id;
      this.selectedDateIni = this.initYear + "-" + (month<10 ? "0"+month : month) + "-01";
      this.selectedDateFin = this.initYear + "-" + (month<10 ? "0"+month : month) +  "-" + this.utils.getLasDay(this.initYear, month);
      //console.log(">> this.selectedDateIni= ", this.selectedDateIni);
      //console.log(">> this.selectedDateFin= ", this.selectedDateFin);
    }
  }
  onCommissionGroupChange=(e: any[])=>{

    this.selectedCommissionGroup = e;
    if(this.selectedCommissionGroup.length>0){

      this.createdDateIni = null;
      this.createdDateFin = null;

      this.selectedDateIni = null;
      this.selectedDateFin = null;

      this.viewMonthDD = 0;
      this.viewDateIni = 0;
      this.viewDateFin = 0;

      this.viewCommissionsBtn = 0;
      this.viewComplementsBtn = 0;
      this.viewCheckComplements = 0;

      this.complements=false;

      //TERCIA / FISOFO
      if(this.selectedCommissionGroup[0].id === 1 || this.selectedCommissionGroup[0].id === 5) {
        //Simulador
        if(this.isChild === "n") {
          this.viewDateIni = 1;
          this.viewDateFin = 1;
          this.labelFechaIni = "Fecha Inicio";
        }
      }

      //PROMOTOR
      if(this.selectedCommissionGroup[0].id === 2) {
        //Simulador
        if(this.isChild === "n") {
          this.viewDateIni = 1;
          this.viewDateFin = 0;
          this.labelFechaIni = "Fecha";

          this.viewCommissionsBtn = 1;
          this.viewComplementsBtn = 1;
          this.viewCheckComplements = 1;
        }
      }

      //COORDINADOR EXTERNO
      if(this.selectedCommissionGroup[0].id === 3) {
        //Simulador
        if(this.isChild === "n") {
          this.viewDateIni = 1;
          this.viewDateFin = 1;
          this.labelFechaIni = "Fecha Inicio";
        }
      }

    }
console.log(this.selectedCommissionGroup[0].id)
  }
  
  onViewGroups=()=>{
    if(this.selectedCommissionGroup.length>0){
      let commissionGroup = this.selectedCommissionGroup[0].id;
      if(commissionGroup === 2) {
        if(this.selectedDateIni != null && this.selectedDateIni.length > 0) {
          this.getCommissionCollectGroups(this.selectedDateIni, commissionGroup);
        }else{
          this.toastr.info('Seleccione una Fecha!');
        }
      }else{
        this.toastr.info('Esta función solo está disponible para el grupo de Asesor Interno/Aliado Comercial!');
      }
    }else{
      this.toastr.info('Seleccione un grupo de Comisiones!');
    }
  }
  onViewCommissions=()=>{
    if(this.selectedCommissionGroup.length>0){
      let commissionGroup = this.selectedCommissionGroup[0].id;
      if(commissionGroup === 2) {
        if(this.selectedDateIni != null && this.selectedDateIni.length > 0) {
          this.getCommissionCollectSalePromotions(this.selectedDateIni, commissionGroup, this.simulate ? 1 : 0);
        }else{
          this.toastr.info('Seleccione una Fecha!');
        }
      }else{
        this.toastr.info('Esta función solo está disponible para el grupo de Asesor Interno/Aliado Comercial!');
      }
    }else{
      this.toastr.info('Seleccione un grupo de Comisiones!');
    }
  }
  onViewComplements=()=>{
    if(this.selectedCommissionGroup.length>0){
      let commissionGroup = this.selectedCommissionGroup[0].id;
      if(commissionGroup === 2) {
        let modalRef=this.modalService.open(ModalDateSelectionComponent, {centered:true, size:'sm', backdrop:'static', keyboard:false});
            modalRef.result.then(
              data=> console.log(data),
              reason=> {
                if(reason != null) {
                  this.getCommissionCollectPromotorComplementsApplied(reason, commissionGroup);
                }
              }
            );
      }else{
        this.toastr.info('Esta función solo está disponible para el grupo de Asesor Interno/Aliado Comercial!');
      }
    }else{
      this.toastr.info('Seleccione un grupo de Comisiones!');
    }
  }
  onViewDashboard=()=>{
    //this.getCommissionSimulatorResults("2021-12-30", 2, 1, 0);
    //return;
    let url="";
    if(this.selectedCommissionGroup.length>0){
      let commissionGroup = this.selectedCommissionGroup[0].id;
      //TERCIA REGIONAL
      if(commissionGroup === 1) {
        url="https://datastudio.google.com/embed/reporting/5329f5a4-bca2-41a2-a00a-5eaa18ca037d/page/iRVKC";
      }
      //ASESOR (INTERNO / ALIADO COMERCIAL)
      if(commissionGroup === 2) {
        url="https://datastudio.google.com/embed/reporting/a9611b61-e055-42bb-8ead-28433cf44d92/page/p_s1q6qurqmc";
      }
      //COORDINADOR EXTERNO
      if(commissionGroup === 3) {
        url="https://datastudio.google.com/embed/reporting/83f6c382-a134-4f1f-9a71-8925b288277b/page/p_mlveuqiwmc";
      }

      let container = document.getElementById("dashboard-container");
      let frame = document.getElementById("dashboard-frame");

      let container2 = document.getElementById("dashboard-container2");
      let frame2 = document.getElementById("dashboard-frame2");

      if(frame != null && frame != undefined) container.removeChild(frame);
      if(frame2 != null && frame2 != undefined) container2.removeChild(frame2);

      var newFrame = document.createElement("iframe");
      newFrame.setAttribute("id", "dashboard-frame");
      newFrame.setAttribute("src", url);
      newFrame.style.width = "100%";
      newFrame.style.height = "800px";

      container.appendChild(newFrame);

      if(commissionGroup === 1) {
        //CALL CENTER
        url="https://datastudio.google.com/embed/reporting/2a325ddc-4aa7-4bf9-b61e-8a814ff4ab49/page/p_l3f7hv4umc";

        var newFrame2 = document.createElement("iframe");
        newFrame2.setAttribute("id", "dashboard-frame2");
        newFrame2.setAttribute("src", url);
        newFrame2.style.width = "100%";
        newFrame2.style.height = "800px";

        container2.appendChild(newFrame2);
      }

    }else{
      this.toastr.info('Seleccione una grupo!');
    }
  }

  onGenerateCommissionSimulator=()=> {
    if(this.isChild == "y"){ // Solo consulta los resultados de la Simulación

      if(this.selectedCommissionGroup.length>0){

        let commissionGroup = this.selectedCommissionGroup[0].id;
        if(commissionGroup === 2) {
          if(this.selectedDateIni != null && this.selectedDateIni.length > 0) {
            this.getCommissionSimulatorResults(this.selectedDateIni, commissionGroup, 1, 4);
          }else{
            this.toastr.info('Seleccione una Fecha!');
          }
        }else{
            this.getCommissionSimulatorResults("0000", commissionGroup, 1, 4);
        }
      }else{
        this.toastr.info('Seleccione un grupo de Comisiones!');
      }

    } else { // Genera la Simulación y regresa los resultados
      if(this.selectedCommissionGroup.length>0){

        let commissionGroup = this.selectedCommissionGroup[0].id;
        if(commissionGroup === 2 && this.complements){
          let d = new Date();
          let month = '' + (d.getMonth() + 1), day = '' + d.getDate(), year = d.getFullYear();

          if (month.length < 2) month = '0' + month;
          if (day.length < 2) day = '0' + day;

          this.selectedDateIni = [year, month, day].join('-');
        }

        console.log(">> commissionGroup= " + commissionGroup);
        console.log(">> this.selectedDateIni= " + this.selectedDateIni);
        console.log(">> this.selectedDateFin= " + this.selectedDateFin);

        if((commissionGroup === 1 && this.selectedDateIni != null && this.selectedDateFin != null) ||
           (commissionGroup === 3 && this.selectedDateIni != null && this.selectedDateFin != null) ||
           (commissionGroup === 4 && this.selectedDateIni != null && this.selectedDateFin != null) ||
           (commissionGroup === 5 && this.selectedDateIni != null && this.selectedDateFin != null) ||
           (commissionGroup === 2 && this.selectedDateIni != null)){

          if(!this.simulate){
            let _text = "Se generarán las <b>Comisiones</b> de manera irreversible en la fecha seleccionada! Está seguro de generar las <b>Comisiones</b>?";
            if(commissionGroup === 2 && this.complements){
              _text = "Se generarán los <b>Complementos</b> del mes pasado de manera irreversible! Está seguro de generar los <b>Complementos</b>?";
            }
            let modalRef=this.modalService.open(ModalConfirmComponent, {centered:true, size:'sm', backdrop:'static', keyboard:false});
            modalRef.componentInstance.header='Desea generar las Comisiones?';
            modalRef.componentInstance.text=_text;
            modalRef.componentInstance.viewHeader = 0;
            modalRef.componentInstance.acceptText = 'Sí, Generar';
            modalRef.componentInstance.cancelText = 'Cancelar';
            modalRef.result.then(
              data=> console.log(data),
              reason=> {
                if(reason ==='accept') {
                    this.loading = 1;
                    if(commissionGroup === 2 && this.complements){
                      this.getCommissionCollectPromotorComplements(this.selectedDateIni, commissionGroup, 0);
                    }else{
                      if(commissionGroup === 5){
                        this.getCommissionCollectFisofo(this.selectedDateIni, this.selectedDateFin, 0);
                      }else{
                        this.getCommissionCollect(this.selectedDateIni, this.selectedDateFin, commissionGroup, 0);
                      }
                    }
                }
              }
            );
          }else{
            this.loading = 1;
            if(commissionGroup === 2 && this.complements){
              this.getCommissionCollectPromotorComplements(this.selectedDateIni, commissionGroup, 1);
            }else{
              if(commissionGroup === 5){
                this.getCommissionCollectFisofo(this.selectedDateIni, this.selectedDateFin, 1);
              }else{
                this.getCommissionCollect(this.selectedDateIni, this.selectedDateFin, commissionGroup, 1);
              }
            }
          }
        } else {
          this.toastr.info('Seleccione una Fecha 2!');
        }
      }else{
        this.toastr.info('Seleccione un grupo de Comisiones!');
      }

    }

  }

  onGenerateCommissionSimulator2=()=> {
    if(this.isChild == "y"){ // Solo consulta los resultados de la Simulación
      if(this.selectedCommissionGroup.length>0){
        let commissionGroup = this.selectedCommissionGroup[0].id;
        
        if(commissionGroup === 2) {
          if(this.selectedDateIni != null && this.selectedDateIni.length > 0) {
            this.getCommissionSimulatorResults2(this.selectedDateIni, commissionGroup, 1);
          }else{
            this.toastr.info('Seleccione una Fecha!');
          }
        }else if(commissionGroup === 1){
          if(this.selectedDateIni != null && this.selectedDateIni.length > 0) {
            this.getCommissionSimulatorResults2(this.selectedDateIni, commissionGroup, 1);
          }else{
            this.toastr.info('Seleccione una Fecha!');
          }
        }
      }else{
        this.toastr.info('Seleccione un grupo de Comisiones!');
      }

    } else { // Genera la Simulación y regresa los resultados
      if(this.selectedCommissionGroup.length>0){
        let commissionGroup = this.selectedCommissionGroup[0].id;
        if(commissionGroup === 2 && this.complements){
          let d = new Date();
          let month = '' + (d.getMonth() + 1), day = '' + d.getDate(), year = d.getFullYear();
          if (month.length < 2) month = '0' + month;
          if (day.length < 2) day = '0' + day;
          this.selectedDateIni = [year, month, day].join('-');
        }

        console.log(">> commissionGroup= " + commissionGroup);
        console.log(">> this.selectedDateIni= " + this.selectedDateIni);
        console.log(">> this.selectedDateFin= " + this.selectedDateFin);

        if((commissionGroup === 1 && this.selectedDateIni != null && this.selectedDateFin != null) ||
           (commissionGroup === 3 && this.selectedDateIni != null && this.selectedDateFin != null) ||
           (commissionGroup === 4 && this.selectedDateIni != null && this.selectedDateFin != null) ||
           (commissionGroup === 5 && this.selectedDateIni != null && this.selectedDateFin != null) ||
           (commissionGroup === 2 && this.selectedDateIni != null)){

          if(!this.simulate){
            let _text = "Se generarán las <b>Comisiones</b> de manera irreversible en la fecha seleccionada! Está seguro de generar las <b>Comisiones</b>?";
            
            let modalRef=this.modalService.open(ModalConfirmComponent, {centered:true, size:'sm', backdrop:'static', keyboard:false});
            modalRef.componentInstance.header='Desea generar las Comisiones?';
            modalRef.componentInstance.text=_text;
            modalRef.componentInstance.viewHeader = 0;
            modalRef.componentInstance.acceptText = 'Sí, Generar';
            modalRef.componentInstance.cancelText = 'Cancelar';
            modalRef.result.then(
              data=> console.log(data),
              reason=> {
                if(reason ==='accept') {
                    this.loading = 1;
                    if(commissionGroup === 2 && this.complements){
                      this.getCommissionCollectPromotorComplements(this.selectedDateIni, commissionGroup, 0);
                    }else{
                      if(commissionGroup === 5){
                        this.getCommissionCollectFisofo(this.selectedDateIni, this.selectedDateFin, 0);
                      }else{
                        this.getCommissionCollect2(this.selectedDateIni, this.selectedDateFin, commissionGroup, 0);
                      }
                    }
                }
              }
            );
          }else{
            this.loading = 1;
            if(commissionGroup === 2 && this.complements){
              this.getCommissionCollectPromotorComplements(this.selectedDateIni, commissionGroup, 1);
            }else{
              if(commissionGroup === 5){
                this.getCommissionCollectFisofo(this.selectedDateIni, this.selectedDateFin, 1);
              }else{
                this.getCommissionCollect2(this.selectedDateIni, this.selectedDateFin, commissionGroup, 1);
              }
            }
          }
        } else {
          this.toastr.info('Seleccione una Fecha 2!');
        }
      }else{
        this.toastr.info('Seleccione un grupo de Comisiones!');
      }

    }

  }
  
  onTotalMotiveClick=(e:any, motive:number)=>{
    e.stopPropagation();
    e.preventDefault();
    let commissionGroup = this.selectedCommissionGroup[0].id;
    if(commissionGroup === 2) {
      if(this.selectedDateIni != null && this.selectedDateIni.length > 0) {
        this.getCommissionSimulatorResults(this.selectedDateIni, commissionGroup, this.simulate ? 1 : 0, motive);
      }else{
        this.toastr.info('Seleccione una Fecha!');
      }
    }
  }

  // GET DATA
  getCatalogs=()=> {
    forkJoin(
      this.catEmployeeJobService.getCommissionGroup()
    )
    .pipe(
      tap(([groupJobResp]:[any])=> {
        if(groupJobResp) {
          // this.commissionGroupCatalog=groupJobResp.data.sort(this.utils.sortBy('description'));
          // if(this.isChild === "n") {
          //   let option2 = new CatalogModel();
          //   option2.id = 5;
          //   option2.description = "FISOFO";
          //   this.commissionGroupCatalog.push(option2);
          // }
          let option2 = new CatalogModel();
          option2.id = 2;
          option2.description = "ASESOR (INTERNO / ALIADO COMERCIAL)";
          this.commissionGroupCatalog.push(option2);
        }
      }),
      catchError(error=> {
        console.log(error);
        this.viewStatus=-1;
        return of(
          this.toastr.error('Ocurrió un error al cargar catálogos.')
        );
      })
    )
    .subscribe();
  }

  getCommissionCollectFisofoApplied=(simulateDateIni:string, simulateDateFin:string)=>{
    this.loading = 1;
    this.commissionFisofoService.getCommissionCollectApplied(simulateDateIni, simulateDateFin)
      .subscribe((resp:any)=> {
        if(resp && resp.codeHttpStatus===200) {
          if(resp.data != null && resp.data.length > 0){
            let newId = 1;
            let _title = "FISOFO (" + simulateDateIni + " A " + simulateDateFin + ")";
            if(this.tabs.length > 0){
              this.tabs = this.tabs.filter(tab => tab.title !== _title);
              if(this.tabs.length > 0){
                let lastTab = this.tabs.reduce((p, c) => p.id > c.id ? p : c);
                newId = lastTab.id + 1;
              }
            }

            this.tabs.push({ id:newId, title:_title, target:resp.data, isPromotor:false, isComplement:false, isFisofo:true, motiveId:0 });
            this.nav.select(newId);
            this.loading = 0;

            console.log(">> this.tabs=", this.tabs);
            console.log(">> newIdTab=", newId);

          }else{
            this.loading = 0;
            this.toastr.info('No hay resultados de Fisofo!');
          }
        }else{
          this.toastr.error('Ha ocurrido un problema al intentar obtener los resultados!');
        }
      });

  }
  getCommissionCollectFisofo=(simulateDateIni:string, simulateDateFin:string, simulateId:number)=>{
    this.commissionFisofoService.getCommissionCollect(simulateDateIni, simulateDateFin, simulateId)
      .subscribe((resp:any)=> {
        if(resp && resp.codeHttpStatus===200) {
          if(resp.data != null && resp.data.length > 0){
            let newId = 1;
            let _title = "FISOFO (" + simulateDateIni + " A " + simulateDateFin + ")";
            if(this.tabs.length > 0){
              this.tabs = this.tabs.filter(tab => tab.title !== _title);
              if(this.tabs.length > 0){
                let lastTab = this.tabs.reduce((p, c) => p.id > c.id ? p : c);
                newId = lastTab.id + 1;
              }
            }

            this.tabs.push({ id:newId, title:_title, target:resp.data, isPromotor:false, isComplement:false, isFisofo:true, motiveId:0 });
            this.nav.select(newId);
            this.loading = 0;

            console.log(">> this.tabs=", this.tabs);
            console.log(">> newIdTab=", newId);

          }else{
            this.loading = 0;
            this.toastr.info('No hay resultados de Fisofo!');
          }
        }else{
          this.toastr.error('Ha ocurrido un problema al intentar generar los resultados!');
        }
      });

  }

  getCommissionCollectPromotorComplementsApplied=(simulateDate:string, commissionGroup:number)=>{
    this.loading = 1;
    this.commissionSimulatorService.getCommissionCollectPromotorComplementsApplied(simulateDate, commissionGroup)
      .subscribe((resp:any)=> {
        if(resp && resp.codeHttpStatus===200) {
          if(resp.data != null && resp.data.length > 0){
            let newId = 1;
            const current = new Date();
            current.setMonth(current.getMonth()-1);
            const previousMonth = current.toLocaleString('default', { month: 'long' });
            let _title = "COMPLEMENTOS (" + this.getDisplayMonth(simulateDate) + ")";

            if(this.tabs.length > 0){
              this.tabs = this.tabs.filter(tab => tab.title !== _title);
              if(this.tabs.length > 0){
                let lastTab = this.tabs.reduce((p, c) => p.id > c.id ? p : c);
                newId = lastTab.id + 1;
              }
            }

            this.tabs.push({ id:newId, title:_title, target:resp.data, isPromotor:true, isComplement:true, isFisofo:false, motiveId:0 });
            this.nav.select(newId);
            this.loading = 0;

            console.log(">> this.tabs=", this.tabs);
            console.log(">> newIdTab=", newId);

          }else{
            this.loading = 0;
            this.toastr.info('No hay resultados de Complementos!');
          }
        }else{
          this.toastr.error('Ha ocurrido un problema al intentar obtener los Complementos!');
        }
      });

  }
  getCommissionCollectPromotorComplements=(simulateDate:string, commissionGroup:number, simulateId:number)=>{
    //simulateDate = '2021-09-13';
    this.commissionSimulatorService.getCommissionCollectPromotorComplements(simulateDate, commissionGroup, simulateId)
      .subscribe((resp:any)=> {
        if(resp && resp.codeHttpStatus===200) {
          if(resp.data != null && resp.data.length > 0){
            let newId = 1;
            const current = new Date();
            current.setMonth(current.getMonth()-1);
            const previousMonth = current.toLocaleString('default', { month: 'long' });
            let _title = "COMPLEMENTOS (" + previousMonth.toUpperCase() + ")";

            if(this.tabs.length > 0){
              this.tabs = this.tabs.filter(tab => tab.title !== _title);
              if(this.tabs.length > 0){
                let lastTab = this.tabs.reduce((p, c) => p.id > c.id ? p : c);
                newId = lastTab.id + 1;
              }
            }

            this.tabs.push({ id:newId, title:_title, target:resp.data, isPromotor:true, isComplement:true, isFisofo:false, motiveId:0 });
            this.nav.select(newId);
            this.loading = 0;

            console.log(">> this.tabs=", this.tabs);
            console.log(">> newIdTab=", newId);

          }else{
            this.loading = 0;
            this.toastr.info('No hay resultados de Complementos!');
          }
        }else{
          this.toastr.error('Ha ocurrido un problema al intentar generar los Complementos!');
        }
      });

  }

  getCommissionCollectSalePromotions=(simulateDate:string, commissionGroup:number, simulateId:number)=>{
    if(this.tabs.length < 7){
      this.loading = 1;
      // this.commissionSimulatorService.getCommissionCanePromotorRequests(simulateDate)
      // .subscribe((resp:any)=> {
      //   if(resp && resp.codeHttpStatus===200) {
      //     this.loading2 = 1;
      //     if(resp.data != null && resp.data.length > 0){
      //       let newId = 1;
      //       if(this.tabs.length > 0){
      //         let lastTab = this.tabs.reduce((p, c) => p.id > c.id ? p : c);
      //         newId = lastTab.id + 1;
      //       }

      //       this.tabs.push({ id:newId, title:"COMISIONES POR ASESOR (" + simulateDate + ")", target:resp.data, isPromotor:true, isComplement:false, isFisofo:false, motiveId:0, sendCane:1 });
      //       this.nav.select(newId);
      //       this.loading = 0;

      //       console.log(">> this.tabs=", this.tabs);
      //       console.log(">> newIdTab=", newId)
      //     }else{
      //       this.toastr.info('No hay resultados de Comisiones!');
      //       this.loading = 0;
      //       this.loading2 = 0;
      //     }
      //   }else{
      //     this.toastr.error('Ha ocurrido un problema al intentar generar las comisiones!');
      //   }
      // });

      this.commissionSimulatorService.getCommissionCollectSalePromotions(simulateDate, commissionGroup, simulateId)
      .subscribe((resp:any)=> {
        if(resp && resp.codeHttpStatus===200) {
          this.loading2 = 1;
          if(resp.data != null && resp.data.length > 0){
            let newId = 1;
            if(this.tabs.length > 0){
              //this.tabs = this.tabs.filter(tab => tab.title !== "COMISIONES (" + simulateDate + ")");
              let lastTab = this.tabs.reduce((p, c) => p.id > c.id ? p : c);
              newId = lastTab.id + 1;
            }

            this.tabs.push({ id:newId, title:"COMISIONES POR CRÉDITO (" + simulateDate + ")", target:resp.data, isPromotor:true, isComplement:false, isFisofo:false, motiveId:0, sendCane:1 });
            this.nav.select(newId);
            this.loading = 0;

            console.log(">> this.tabs=", this.tabs);
            console.log(">> newIdTab=", newId)
          }else{
            this.toastr.info('No hay resultados de Comisiones!');
            this.loading = 0;
            this.loading2 = 0;
          }
        }else{
          this.toastr.error('Ha ocurrido un problema al intentar generar las comisiones!');
        }
      });
    }else{
      this.toastr.info('Solo se pueden tener abiertos 6 tabs abiertos!');
    }
  }

  getCommissionCollectGroups=(simulateDate:string, commissionGroup:number)=>{
    if(this.tabs.length < 7){
      this.loading = 1;
      this.commissionSimulatorService.getCommissionCollectGroupApplied(simulateDate, commissionGroup)
      .subscribe((resp:any)=> {
        if(resp && resp.codeHttpStatus===200) {
          this.loading2 = 1;
          if(resp.data != null && resp.data.length > 0){
            let newId = 1;
            if(this.tabs.length > 0){
              //this.tabs = this.tabs.filter(tab => tab.title !== "COMISIONES (" + simulateDate + ")");
              let lastTab = this.tabs.reduce((p, c) => p.id > c.id ? p : c);
              newId = lastTab.id + 1;
            }

            this.dataGroups=resp.data;
            this.tabs.push({ id:newId, title:"COMISIONES POR ASESOR (" + simulateDate + ")", target:this.dataGroups, isFisofo:false, isGroup:true });
            this.nav.select(newId);
            this.loading = 0;
            this.isGroup=true;

            console.log(">> this.tabs=", this.tabs);
            console.log(">> newIdTab=", newId)
          }else{
            this.toastr.info('No hay resultados de Asesores!');
            this.loading = 0;
            this.loading2 = 0;
          }
        }else{
          this.toastr.error('Ha ocurrido un problema al intentar encontrar las comisiones de los asesores!');
        }
      });
    }else{
      this.toastr.info('Solo se pueden tener abiertos 6 tabs abiertos!');
    }
  }

  getCommissionSimulatorResults=(simulateDate:string, commissionGroup:number, simulateId:number, motiveId:number)=> {
    this.loading = 1;
    this.commissionSimulatorService.getCommissionCollectResults(simulateDate, commissionGroup, simulateId, motiveId)
    .subscribe((resp:any)=> {
      if(resp && resp.codeHttpStatus===200) {
        if(resp.data != null && resp.data.length > 0){

          let newId = 1;
          let _title = "", _title2 = "";
          let _isPromotor = false;

          if(commissionGroup === 1){
            _title = "TERCIA REGIONAL (" + this.selectedDateIni + (this.selectedDateFin != null ? " A " + this.selectedDateFin + ")" : ")");
            _title2 = "TERCIA CALL CENTER (" + this.selectedDateIni + (this.selectedDateFin != null ? " A " + this.selectedDateFin + ")" : ")");
          }
          if(commissionGroup === 2){
            _isPromotor = true;
            _title = "ASESOR INTERNO / ALIADO COMERCIAL (" + this.selectedDateIni + (this.selectedDateFin != null ? " A " + this.selectedDateFin + ")" : ")");
          }
          if(commissionGroup === 3){
            _title = "COORDINADOR EXTERNO (" + this.selectedDateIni + (this.selectedDateFin != null ? " A " + this.selectedDateFin + ")" : ")");
          }

          if(this.tabs.length > 0){
            //this.tabs = this.tabs.filter(tab => tab.title !== _title);
            let lastTab = this.tabs.reduce((p, c) => p.id > c.id ? p : c);
            newId = lastTab.id + 1;
          }

          if(commissionGroup === 1){
            this.tabs.push({ id:newId, title:_title, target:resp.data.filter(item => item.employeeJobId === 3 || item.employeeJobId === 5 || item.employeeJobId === 7), isPromotor:_isPromotor, isComplement:false, isFisofo:false, motiveId:motiveId });
            this.tabs.push({ id:newId + 1, title:_title2, target:resp.data.filter(item => item.employeeJobId === 8 || item.employeeJobId === 9 || item.employeeJobId === 10), isPromotor:_isPromotor, isComplement:false, isFisofo:false, motiveId:motiveId });
          }else{
            this.tabs.push({ id:newId, title:_title, target:resp.data, isPromotor:_isPromotor, isComplement:false, isFisofo:false, motiveId:motiveId });
          }

          this.nav.select(newId);
          this.loading = 0;

          console.log(">> this.tabs=", this.tabs);
          console.log(">> newIdTab=", newId);
        }else{
          this.toastr.info('No hay resultados de Comisiones!');
          this.loading = 0;
        }
      }else{
        this.toastr.error('Ha ocurrido un problema al intentar generar las comisiones!');
      }
    });
  }

  getCommissionSimulatorResults2=(simulateDate:string, commissionGroup:number, simulateId:number)=> {
    this.loading = 1;
    this.commissionSimulatorService.getCommissionCollectPromotorDirect(simulateDate, simulateId)
    .subscribe((resp:any)=> {
      if(resp && resp.codeHttpStatus===200) {
        if(resp.data != null && resp.data.length > 0){
          

          let newId = 1;
          let _title = "", _title2 = "";
          let _isPromotor = false;
          let _allowAdjustment = true

            if(!this.simulate){
              _allowAdjustment = false;
            } else {
              _allowAdjustment = true;
            }

          if(commissionGroup === 2){
            this.listCommissionProductEmployee = resp.data
          console.error(this.listCommissionProductEmployee)
            _isPromotor = true;
            _title = "ASESOR INTERNO / ALIADO COMERCIAL (" + this.selectedDateIni + (this.selectedDateFin != null ? " A " + this.selectedDateFin + ")" : ")");
          }

          if(this.tabs.length > 0){
            //this.tabs = this.tabs.filter(tab => tab.title !== _title);
            let lastTab = this.tabs.reduce((p, c) => p.id > c.id ? p : c);
            newId = lastTab.id + 1;
          }
/*
          if(commissionGroup === 1){
            this.tabs.push({ id:newId, title:_title, target:resp.data.filter(item => item.employeeJobId === 3 || item.employeeJobId === 5 || item.employeeJobId === 7), isPromotor:_isPromotor, isComplement:false, isFisofo:false, motiveId:motiveId });
            this.tabs.push({ id:newId + 1, title:_title2, target:resp.data.filter(item => item.employeeJobId === 8 || item.employeeJobId === 9 || item.employeeJobId === 10), isPromotor:_isPromotor, isComplement:false, isFisofo:false, motiveId:motiveId });
          }else{
            this.tabs.push({ id:newId, title:_title, target:resp.data, isPromotor:_isPromotor, isComplement:false, isFisofo:false, motiveId:motiveId, sendCane:0, allowAdjustment:_allowAdjustment });
          }
*/
          this.nav.select(newId);
          this.loading = 0;

          console.log(">> this.tabs=", this.tabs);
          console.log(">> newIdTab=", newId);
        }else{
          this.toastr.info('No hay resultados de Comisiones!');
          this.loading = 0;
        }
      }else{
        this.toastr.error('Ha ocurrido un problema al intentar generar las comisiones!');
      }
    });
  }
  getCommissionCollectMotives=(simulateDate:string, commissionGroup:number, simulateId:number)=> {
    this.commissionSimulatorService.getCommissionCollectMotives(simulateDate, commissionGroup, simulateId)
    .subscribe((resp:any)=> {
      if(resp && resp.codeHttpStatus===200) {
          if(resp.data != null && resp.data.length > 0){
            this.listCommissionMotives=resp.data;
            this.listCommissionMotives.forEach((el)=>{
              if(el.id === 0) this.totalCommissionMotive0 = el.total;
              if(el.id === 1) this.totalCommissionMotive1 = el.total;
              if(el.id === 2) this.totalCommissionMotive2 = el.total;
              if(el.id === 3) this.totalCommissionMotive3 = el.total;
              if(el.id === 4) this.totalCommissionMotive4 = el.total;
              if(el.id === 5) this.totalCommissionMotive5 = el.total;
              if(el.id === 6) this.totalCommissionMotive6 = el.total;
              if(el.id === 7) this.totalCommissionMotive7 = el.total;
              if(el.id === 8) this.totalCommissionMotive8 = el.total;
            });
          }
      }
    });
  }
  getCommissionCollect=(createdDateIni:string, createdDateFin:string, commissionGroup:number, simulateId:number)=> {
    this.commissionSimulatorService.getCommissionCollect(createdDateIni, createdDateFin, commissionGroup, simulateId)
      .subscribe((resp:any)=> {
        if(resp && resp.codeHttpStatus===200) {
          if(resp.data != null && resp.data.length > 0){

            let newId = 1;
            let _title = "", _title2="";
            let _isPromotor = false;

            if(commissionGroup === 1){
              _title = "TERCIA REGIONAL (" + createdDateIni + (createdDateFin != null ? " A " + createdDateFin + ")" : ")");
              _title2 = "TERCIA CALL CENTER (" + this.selectedDateIni + (this.selectedDateFin != null ? " A " + this.selectedDateFin + ")" : ")");
            }
            if(commissionGroup === 2){
              _isPromotor = true;
              _title = "ASESOR INTERNO / ALIADO COMERCIAL (" + createdDateIni + (createdDateFin != null ? " A " + createdDateFin + ")" : ")");
            }
            if(commissionGroup === 3){
              _title = "COORDINADOR EXTERNO (" + createdDateIni + (createdDateFin != null ? " A " + createdDateFin + ")" : ")");
            }

            if(this.tabs.length > 0){
              this.tabs = this.tabs.filter(tab => tab.title !== _title);
              if(this.tabs.length > 0){
                let lastTab = this.tabs.reduce((p, c) => p.id > c.id ? p : c);
                newId = lastTab.id + 1;
              }
            }

            if(commissionGroup === 1){
              this.tabs.push({ id:newId, title:_title, target:resp.data.filter(item => item.employeeJobId === 3 || item.employeeJobId === 5 || item.employeeJobId === 7), isPromotor:_isPromotor, isComplement:false, isFisofo:false, motiveId:0 });
              this.tabs.push({ id:newId + 1, title:_title2, target:resp.data.filter(item => item.employeeJobId === 8 || item.employeeJobId === 9 || item.employeeJobId === 10), isPromotor:_isPromotor, isComplement:false, isFisofo:false, motiveId:0 });
            }else{
              this.tabs.push({ id:newId, title:_title, target:resp.data, isPromotor:_isPromotor, isComplement:false, isFisofo:false, motiveId:0, sendCane:0 });
            }

            this.nav.select(newId);
            this.loading = 0;
            this.isSimulated=true;

            console.log(">> this.tabs=", this.tabs);
            console.log(">> newIdTab=", newId);
            //this.getCommissionCollectMotives(createdDateIni, commissionGroup, simulateId);
          }else{
            this.loading = 0;
            this.toastr.info('No hay resultados de Comisiones!');
          }
        }else{
          this.toastr.error('Ha ocurrido un problema al intentar generar las Comisiones!');
        }
      });
  }

  getCommissionCollect2=(createdDateIni:string, createdDateFin:string, commissionGroup:number, simulateId:number)=> {
    this.commissionSimulatorService.getCommissionCollectPromotorDirect(createdDateIni, simulateId)
      .subscribe((resp:any)=> {
        if(resp && resp.codeHttpStatus===200) {
          if(resp.data != null && resp.data.length > 0){

            console.log(JSON.stringify(resp.data));

            let newId = 1;
            let _title = "", _title2="";
            let _isPromotor = false;
            let _allowAdjustment = true

            if(!this.simulate){
              _allowAdjustment = false;
            } else {
              _allowAdjustment = true;
            }

            if(commissionGroup === 1){
              _title = "TERCIA REGIONAL (" + createdDateIni + (createdDateFin != null ? " A " + createdDateFin + ")" : ")");
              _title2 = "TERCIA CALL CENTER (" + this.selectedDateIni + (this.selectedDateFin != null ? " A " + this.selectedDateFin + ")" : ")");
            }
            if(commissionGroup === 2){
              _isPromotor = true;
              this.listCommissionProductEmployee = resp.data;
              console.error( this.listCommissionProductEmployee)
              //this.dataPromotors = resp.data;
              _title = "ASESOR INTERNO / ALIADO COMERCIAL (" + createdDateIni + (createdDateFin != null ? " A " + createdDateFin + ")" : ")");
            }
            if(commissionGroup === 3){
              _title = "COORDINADOR EXTERNO (" + createdDateIni + (createdDateFin != null ? " A " + createdDateFin + ")" : ")");
            }

            if(this.tabs.length > 0){
              this.tabs = this.tabs.filter(tab => tab.title !== _title);
              if(this.tabs.length > 0){
                let lastTab = this.tabs.reduce((p, c) => p.id > c.id ? p : c);
                newId = lastTab.id + 1;
              }
            }

            if(commissionGroup === 1){
              this.tabs.push({ id:newId, title:_title, target:resp.data.filter(item => item.employeeJobId === 3 || item.employeeJobId === 5 || item.employeeJobId === 7), isPromotor:_isPromotor, isComplement:false, isFisofo:false, motiveId:0 });
              this.tabs.push({ id:newId + 1, title:_title2, target:resp.data.filter(item => item.employeeJobId === 8 || item.employeeJobId === 9 || item.employeeJobId === 10), isPromotor:_isPromotor, isComplement:false, isFisofo:false, motiveId:0 });
            } else if(commissionGroup === 2){
              this.tabs.push({ id:newId, title:_title, target:this.listCommissionProductEmployee, isPromotor:_isPromotor, isComplement:false, isFisofo:false, motiveId:0, sendCane:0, allowAdjustment:_allowAdjustment });
            } else {
              this.tabs.push({ id:newId, title:_title, target:resp.data, isPromotor:_isPromotor, isComplement:false, isFisofo:false, motiveId:0, sendCane:0, allowAdjustment:_allowAdjustment });
            }

            this.nav.select(newId);
            this.loading = 0;
            this.isSimulated=true;

            console.log(">> this.tabs=", this.tabs);
            console.log(">> newIdTab=", newId);
            //this.getCommissionCollectMotives(createdDateIni, commissionGroup, simulateId);
          }else{
            this.loading = 0;
            this.toastr.info('No hay resultados de Comisiones!');
          }
        }else{
          this.toastr.error('Ha ocurrido un problema al intentar generar las Comisiones!');
        }
      });
  }

  openModal(target){
    if(!this.isGroup){
      //console.log("COMISION ORIGINAL: "+ this.comisionOriginalFinal)
      
        this.comisionOriginalFinal = target.commissionAmountFinal;
        console.log("COMISION ORIGINAL FINAL: "+ this.comisionOriginalFinal)
      
      let commissionAdjustment=new CommissionAdjustment();
      commissionAdjustment.creditId=target.iCreditId;
      commissionAdjustment.employeeId=target.vEmployeeId;
      commissionAdjustment.employeeName=target.vNombreEmpleado;
      commissionAdjustment.capitalAmount=target.MontoCapitalTotal;
      // if(target.salePromotionCommissionAmount > target.commissionAmount){
      //   commissionAdjustment.commissionAmount=target.salePromotionCommissionAmount;
      // } else {
      //   commissionAdjustment.commissionAmount=target.commissionAmount;
      // }
      commissionAdjustment.commissionAmount=target.MontoComisionTotal;
      commissionAdjustment.commissionPercent=target.CommissionSchema;
      commissionAdjustment.commissionAdjustmentAmount=target.commissionAdjustmentAmount;
      commissionAdjustment.executionDate=target.executionDate;
      commissionAdjustment.simulated=1; //1.Simulado, 2.NO simulado(listo para aplicar)
      commissionAdjustment.businessLineId=target.businessLineId;
      commissionAdjustment.productId=target.productId
      commissionAdjustment.enviado=0; //0.Por aplicar, 1.Aplicado/Confirmado, 3.Enviado a dispersion
      commissionAdjustment.CommissionAdjustmentAvalible=null;
      commissionAdjustment.CommissionAdjustmentFree=null;
      commissionAdjustment.iCreditIdMotivo =null;
      commissionAdjustment.comentario=null;
      commissionAdjustment.claveEmpleadoDispersion = null;
      let modalRef=this.modalService.open(ModalAdjustCommissionComponent, {centered:true, size:'sm', backdrop:'static'});
      modalRef.componentInstance.simulateDate=this.selectedDateIni;
      modalRef.componentInstance.selectedCommission=commissionAdjustment;
      modalRef.componentInstance.comisionOriginalFinal=this.comisionOriginalFinal;
      modalRef.result.then(
        
        data=> console.log(">> DATA: "+ data),
        reason=> {
          this.viewStatus = 0;
          this.loading=1;
          console.log(">> REASON: "+reason);
          if(reason != 'failure'){
            target.commissionAdjustmentAmount = reason;
            target.commissionAmountFinal = this.comisionOriginalFinal + reason;
          }
          this.loading=0;
          this.viewStatus = 1;
          // if(target.salePromotionCommissionAmount > target.commissionAmount){
          //   target.salePromotionCommissionAmount = target.salePromotionCommissionAmount + reason;
          // } else {
          //   target.commissionAmount = target.commissionAmount + reason;
          // }
        }
      );
    } else {
      console.log("COMISION ORIGINAL: "+ this.comisionOriginalFinalByAsesor)
      this.comisionOriginalFinalByAsesor = target.Comision;

      // if(this.comisionOriginalFinalByAsesor == 0){
      //   this.comisionOriginalFinalByAsesor = target.Comision;
      //   console.log("COMISION ORIGINAL FINAL: "+ this.comisionOriginalFinalByAsesor)
      // }
      let commissionAdjustment=new CommissionAdjustment();
      commissionAdjustment.employeeId=target.vEmployeeId;
      commissionAdjustment.capitalAmount=target.Colocacion;
      commissionAdjustment.commissionAmount=target.ComisionFinal;
      commissionAdjustment.commissionAdjustmentAmount=target.AjusteComision;
      commissionAdjustment.executionDate=target.FechaVenta;
      let modalRef=this.modalService.open(ModalAdjustCommissionComponent, {centered:true, size:'sm', backdrop:'static'});
      modalRef.componentInstance.simulateDate=this.selectedDateIni;
      modalRef.componentInstance.selectedCommission=commissionAdjustment;
      modalRef.componentInstance.comisionOriginalFinal=this.comisionOriginalFinalByAsesor;
      modalRef.componentInstance.creditoMotivo = this.creditoMotivo;
      modalRef.result.then(
        data=> console.log(">> DATA: "+data),
        reason=> {
          console.log(">> REASON: "+reason);
          if (reason != 'failure'){
            target.AjusteComision = reason;
            target.ComisionFinal = this.comisionOriginalFinalByAsesor + reason;
          }
        }
      );
    }
   
  }

  resend=(target)=>{
    let claveEmpleadoDispersion=target.claveEmpleadoDispersion;
    console.log(claveEmpleadoDispersion);
    this.commissionSimulatorService.resendCommission(claveEmpleadoDispersion).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
        } else if (event instanceof HttpResponse) {
          this.modalService.dismissAll('success');
          this.toastr.success('La comision de ha agregado a la cola para enviar correctamente');
          //dtOptions.ajax.reload();
        }
      },
      err => {
        this.modalService.dismissAll('failure');
        this.toastr.error('Ocurrió un error al intentar reenviar la comisión');
      });
  }

  saveCommissionByAsesor=()=>{
    this.commissionSimulatorService.saveCommissionCanePromotorRequest(this.selectedDateIni, localStorage.getItem("UserId"))
      .subscribe((resp:any)=> {
        if(resp && resp.codeHttpStatus===200) {
          this.toastr.success('Las comisiones se guardaron correctamente');
          
        } else {
          this.toastr.error('Ocurrió un error al intentar guardar las comisiones');
        }
      });
  }

  saveCommissionByAsesor2=()=>{
    this.commissionSimulatorService.saveCommissionCanePromotorRequest2(this.selectedDateIni, localStorage.getItem("UserId"))
      .subscribe((resp:any)=> {
        if(resp && resp.codeHttpStatus===200) {
          this.toastr.success('Las comisiones se guardaron correctamente');
          
        } else {
          this.toastr.error('Ocurrió un error al intentar guardar las comisiones');
        }
      });
  }
  
  openModalAdditionalPromotor(){
    let modalRef=this.modalService.open(ModalAdditionalCommissionPromotorComponent, {centered:true, size:'sm', backdrop:'static'});
    modalRef.componentInstance.simulateDate=this.selectedDateIni;
    modalRef.result.then(
      data=> console.log(">> DATA: "+data),
      reason=> {
        console.log(">> JSON CREDITO: "+ JSON.stringify(reason));
        if(reason.toString() != "failure"){
          let targetPromotor = new TargetPromotor();
          targetPromotor.EmpleadoId = reason.employeeId;
          targetPromotor.FechaVenta = reason.fechaCobro;
          targetPromotor.Colocacion = reason.capital
          targetPromotor.Comision = reason.commission;
          targetPromotor.AjusteComision = 0;
          targetPromotor.ComisionFinal = reason.finalCommission;
          targetPromotor.Comentario = reason.comment;
          console.log(">> TARGET ADICIONAL: "+ JSON.stringify(targetPromotor));
          this.dataGroups.push(targetPromotor);
        }
      }
    );
  }

  openModalAdditionalCredit(){
    let modalRef=this.modalService.open(ModalAdditionalCommissionCreditComponent, {backdrop: 'static',size: 'lg', keyboard: false, centered: true});
  }

  acceptCommission(target){
    this.saveListCommissionProductEmployee = target;  
  }

  exportToExcel(){
    const selectedTabId = this.active - 1;
    const comisiones: any = this.tabs[selectedTabId];
    const excelData = {
      name: comisiones.title,
      data: comisiones.target,
      columns: [
        // Las columnas 0 de momento no van en el Reporte de Excel
        { property: "executionDate", header: "Fecha de Ejecución", order: 0 },
        { property: "ComisionApertura", header: "Comisión Apertura", order: 0 },
        { property: "MontoComisionTotal", header: "Monto Comisión Total", order: 0 },
        { property: "Linea", header: "Línea", order: 0 },
        { property: "commissionAdjustmentAmount", header: "Ajuste de Comisión", order: 0 },
        { property: "ApplyPayment", header: "Pago Aplicado", order: 0 },
        { property: "Seguro", header: "Comisión Seguro", order: 0 },
        // Reporte de Excel
        { property: "cliente", header: "Cliente", order: 1 },
        { property: "iCreditId", header: "Crédito", order: 2 },
        { property: "vFinancingId", header: "Clave Producto", order: 3 },
        { property: "Fondeador", header: "Nombre Socio", order: 4 },
        { property: "statusSolicitud", header: "Estatus Solicitud", order: 5 },
        { property: "tipoPromocion", header: "Tipo Promoción", order: 6 },
        { property: "periodicidad", header: "Periodo de Pago", order: 7 },
        { property: "Plazo", header: "Plazo Meses", order: 8 },
        { property: "parcialidad", header: "Parcialidad", order: 9 },
        { property: "idGerente", header: "ID G", order: 10 },
        { property: "gerente", header: "Nom Gerente", order: 11 },
        { property: "idSupervisor", header: "ID S", order: 12 },
        { property: "supervisor", header: "Nom Supervisor", order: 13 },
        { property: "vEmployeeId", header: "ID P", order: 14 },
        { property: "vNombreEmpleado", header: "Nom Promotor", order: 15 },
        { property: "FechaCobro", header: "Fecha de Cobro", order: 16 },
        { property: "anio", header: "Año", order: 17 },
        { property: "anio", header: "Año", order: 18 },
        { property: "mes", header: "Mes", order: 19 },
        { property: "mesNombre", header: "Mes", order: 20 },
        { property: "dia", header: "Día", order: 21 },
        { property: "MontoCapital", header: "Total Pagare", order: 22 },
        { property: "MontoCapitalTotal", header: "Capital", order: 23 },
        { property: "Convenio", header: "Dependencia", order: 24 },
        { property: "Folio", header: "Folio", order: 25 },
        { property: "sucursal", header: "Sucursal", order: 26 },
        { property: "idSolicitud", header: "Numero Solicitud", order: 27 },
        { property: "Estado", header: "Estado", order: 28 },
        { property: "Region", header: "Zona", order: 29 },
        { property: "colectivo", header: "Colectivo", order: 30 },
        //{ property: "Producto", header: "Producto", order: 31 },
        { property: "tipoPromocion", header: "Producto", order: 31 },
        { property: "Empleado", header: "Tipo Asesor", order: 32 },
        { property: "p_especial", header: "P Especial", order: 33 },
        { property: "commissionAmountFinal", header: "Monto Comisión", order: 34 },
        { property: "CommissionSchema", header: "% Comisión", order: 35 },
        { property: "Esquema", header: "Comentario", order: 36 },
        { property: "Categoria", header: "Categorias", order: 37 },
        { property: "nCobradoMesAnt", header: "COL", order: 38 }
      ]
    };

    for( const row of excelData.data){
      // Procesar tipo de empleado
      const tipoEmpleado = row.Empleado;
      if(tipoEmpleado == "ASESOR INTERNO"){
        row.Empleado = "Interno"
      } else if(tipoEmpleado == "ALIADO COMERCIAL"){
        row.Empleado = "Externo"
      } else if(tipoEmpleado == "ASESOR TRAINEE"){
        row.Empleado = "Trainee"
      }

      row.vNombreEmpleado = row.vNombreEmpleado.split(',')[1].trim();


      row.Esquema = row.comentario == undefined || row.comentario == null || row.comentario == "" ? row.Esquema : row.Esquema + " | " + row.comentario;

      row.nCobradoMesAnt = row.nCobradoMesAnt == undefined || row.nCobradoMesAnt == null || (typeof row.nCobradoMesAnt === "string" && row.nCobradoMesAnt == "") ? 0 : row.nCobradoMesAnt;

      // row.FechaCobro = new Intl.DateTimeFormat('es-ES', {
      //   day: '2-digit',
      //   month: '2-digit',
      //   year: 'numeric'
      // }).format(new Date(row.FechaCobro)).toString();
      const [year, month, day] = row.FechaCobro.split("-");
      row.FechaCobro = `${day}/${month}/${year}`;
    }

    console.log("Datos procesados:", excelData.data);

    if (!excelData || !excelData.data || excelData.data.length === 0) return;

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws_data: any[][] = [];

    // Ordenar las columnas por "order"
    const orderedColumns = excelData.columns
      .filter((col: any) => col.order !== undefined && col.order !== null && col.order !== 0)
      .sort((a: any, b: any) => a.order - b.order);
    const numCols = orderedColumns.length;

    // Primera fila: nombre del reporte (mergeada en todas las columnas)
    const firstRow = Array(numCols).fill('');
    firstRow[0] = excelData.name;
    ws_data.push(firstRow);

    // Segunda fila: headers
    ws_data.push(orderedColumns.map((c: any) => c.header));

    // Filas de datos
    excelData.data.forEach((row: any) => {
      const fila: any[] = [];
      orderedColumns.forEach((col: any) => {
        fila.push(row[col.property] != null && row[col.property] != undefined ? row[col.property] : "");
      });
      ws_data.push(fila);
    });

    // Crear worksheet
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(ws_data);

    // Merge para centrar el título
    ws['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: numCols - 1 } }];

    // Ajustar ancho de columnas (mínimo 15)
    ws['!cols'] = orderedColumns.map((col: any) => ({ wch: Math.max(col.header.length, 15) }));

    // Agregar hoja al libro
    XLSX.utils.book_append_sheet(wb, ws, 'Comisiones');

    // Descargar Excel
    XLSX.writeFile(wb, `${excelData.name}.xlsx`);
  }

  aplicarRetencionTotal(target){
    console.log("Retención", target);
    Swal.fire({
      title: 'Confirmar',
      text: `¿Está seguro de que desea aplicar la retención total del crédito ${target.IdCredito}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.isConfirmed) {
        // Lógica para aplicar la retención
        console.log("Retención aplicada", target);
        
      }
    });
  }

}
